import { FundingCategoriesTranslation } from 'locales/de/pages/Fundings/categories';

const en: FundingCategoriesTranslation = {
  title: 'Categoryadministration',
  columns: {
    name: 'Category'
  },
  create: {
    createModalTitle: 'New category',
    editModalTitle: 'Edit category',
    name: 'Categoryname'
  },
  dialogs: {
    deleteConfirm: {
      title: 'Really delete?',
      message: 'Do you really want to delete this category?'
    }
  },
  alerts: {
    errorLoading: 'The categories could not be loaded',
    successfulCreate: 'The category has been created',
    successfulUpdate: 'The category has been edited',
    successfulDelete: 'The category has been deleted',
    failedCreate: 'The category could not be created',
    failedUpdate: 'The category could not be updated',
    failedDelete: 'The category could not be deleted'
  }
};

export default en;
